import { render, staticRenderFns } from "./ChangeSecurityQuestionPage.vue?vue&type=template&id=0492182e&scoped=true&"
import script from "./ChangeSecurityQuestionPage.vue?vue&type=script&lang=js&"
export * from "./ChangeSecurityQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492182e",
  null
  
)

export default component.exports